import React from "react";

export default function Header() {
  return (
    <header className="header">
      <div className="container header-container">
        <div className="logo">Yaich Translations</div>

        <nav className="nav">
          <a href="#about">About</a>
          <a href="#services">Services</a>
          <a href="#credentials">Credentials</a>
          <a href="#how-it-works">Process</a>
          <a href="#faq">FAQ</a>
          <a href="/contact">Contact</a>
        </nav>

        <a href="/#quote" className="btn btn-primary">
          Get a Quote
        </a>
      </div>
    </header>
  );
}